import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";

toast.configure();

const getRencImpNotZero = async (axiosInstance) => {
  return await axiosInstance
    .get("rencanaimp/")
    .then((res) => {
      let datas = res.data;
      datas = datas.filter((data) => Number(data.anggaran_tersisa) > 0);
      return { data: datas };
    })
    .catch((error) => {
      console.error(error);
      toast.error(`GET non 0 Rencana Implementasi ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    });
};

export default getRencImpNotZero;
